import { mapActions, mapState } from 'pinia';
import { useContentStore } from '../stores/content/index.js';
import TranslationsMixin from './translations';

export default {
  name: 'BackLinkMixin',
  mixins: [TranslationsMixin],
  // Called externally due to vue-router bug
  async beforeRouteUpdate(to, from) {
    await this.updateEmbeddedFaqList({ contentId: from.params.faqId });
    await this.updateEmbeddedFaqList({ contentId: to.params.faqId });

    this.configureBackLink(to, from);
  },
  data() {
    return {
      isBackToHome: null,
      isBackToResults: null,
      navigatedTo: null,
      navigatedFrom: null,
      backLinkText: '',
      prevUrl: '',
    };
  },
  computed: {
    ...mapState(useContentStore, ['embeddedFaqList', 'getLastEmbeddedFaq']),
    getComputedBackLinkText() {
      return this.backLinkText;
    },
    getComputedBackLinkUrl() {
      return this.prevUrl;
    },
    hasFilteredResults() {
      return (route) => Object.keys(route.query).length > 0;
    },
    isDirectHit() {
      return (fromRoute) => (
        !fromRoute.name
        && fromRoute.path === '/'
        && !this.hasFilteredResults(fromRoute)
        && this.embeddedFaqList.length < 1
      );
    },

    shouldReturnHome() {
      return (from) => (
        this.isDirectHit(from)
        || from.name === 'landing'
      );
    },
    shouldReturnToResults() {
      return (to) => (
        (
          this.embeddedFaqList.length > 0
          && to.params.faqId
        ) || (
          to.params.faqId
          && this.hasFilteredResults(to)
        )
      );
    },
  },
  methods: {
    ...mapActions(useContentStore, ['updateEmbeddedFaqList']),
    async onBackLinkClicked() {
      if (this.isBackToHome) this.$router.push({ name: 'landing' });
      else if (this.isBackToResults) {
        this.$router.push({
          name: 'issuesView',
          query: {
            ...this.navigatedTo.query,
          },
        });
      } else this.$router.back();
    },
    configureBackLink(to, from) {
      this.navigatedFrom = from;
      this.navigatedTo = to;

      if (this.shouldReturnToResults(to, from)) {
        this.isBackToHome = false;
        this.isBackToResults = this.embeddedFaqList.length < 1;
        this.backLinkText = this.translations.commonSettings.navigation.returnToSearchResultsLabel;
        this.prevUrl = from.fullPath === '/'
          ? `/${to.params.locale}/${to.params.path}/faq/${(this.getLastEmbeddedFaq || {}).contentId || ''}`
          : from.fullPath;
      } else {
        this.isBackToHome = true;
        this.backLinkText = this.translations.navigation.breadcrumbs.title;
        this.prevUrl = `/${to.params.locale}/${to.params.path}`;
      }
    },
  },
};
